// extracted by mini-css-extract-plugin
export default {"card":"likee-module__card--qJ3PK","imgContainer":"likee-module__imgContainer--mKsKt","bubble":"likee-module__bubble--l4dyL","text":"likee-module__text--wwSiT"};